import { useTranslation } from 'react-i18next';

import { faCheck, faCopy } from '@fortawesome/pro-light-svg-icons';

import { useCopyToClipboard } from '@spacefill/uikit/src/utils/useCopyToClipboard';

import { AiChatMessageIconButton } from './AiChatMessageIconButton';

const AiChatMessageCopyButton = ({ text, actionName }) => {
    const { t } = useTranslation();
    const { copy, copied } = useCopyToClipboard();

    return (
        <AiChatMessageIconButton
            icon={copied ? faCheck : faCopy}
            label={t('Copy')}
            title={copied ? t('Copied!') : t('Copy')}
            actionName={actionName}
            onClick={() => copy(text)}
            isHighlighted={copied}
        />
    );
};

export { AiChatMessageCopyButton };
